import "./home.scss";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import PromoCard from "../../components/promoCard/PromoCard";
import { Link } from "react-router-dom";
import HomepagePopup from "../../components/homepagePopup/HomepagePopup";

const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="header">
          <div className="headerContent">
            <div className="imageContainer">
              <img
                src="https://images2.imgbox.com/88/81/dnWatbMl_o.jpg"
                className="headerImage image1"
                alt="Food 1"
              />
              <img
                src="https://images2.imgbox.com/2d/06/eraHP54y_o.jpg"
                className="headerImage image2"
                alt="Food 2"
              />
              <img
                src="https://images2.imgbox.com/e3/56/HOSF2oq5_o.jpg"
                className="headerImage image3"
                alt="Food 3"
              />
            </div>
            <div className="contentWrapper">
              <h1>Tu rządzi smak</h1>
              <p>
                Zamów już teraz w szybki i wygodny sposób wybrane danie, a my
                dostarczymy je najszybciej jak to będzie możliwe
              </p>
              <Link to="/menu" style={{ textDecoration: "none" }}>
                <button className="menuButton">ZOBACZ MENU</button>
              </Link>
            </div>
          </div>
        </div>
        <div className="homeWrapper">
          <div className="left">
            <div className="homeWrapperAbout">
              <div className="aboutLeft">
                <h3>Dowiedz się więcej o naszej restauracji</h3>
                <p>
                  Zdecydowanie najlepsze miejsce w mieście. U nas skosztujesz
                  niepowtarzalnej pizzy, która jest przygotowywana według
                  autorskiej receptury, przez wykwalifikowanych kucharzy.
                  Dokładamy wszelkich starań, aby nasze potrawy były aromatyczne
                  i świeże, dlatego podjęliśmy współprace z lokalnymi
                  dostawcami, którzy gwarantują nam wysokiej jakości produkty.
                  Dzięki tak dobrym kontaktom możemy Wam zapewnić idealny smak
                  naszych dań.{" "}
                </p>
                <Link to="/menu" style={{ textDecoration: "none" }}>
                  <button className="menuButton">ZOBACZ MENU</button>
                </Link>
              </div>
              <div className="aboutRight">
                <img
                  className="pictureOne"
                  src="https://images2.imgbox.com/33/fd/USV84ILA_o.jpg"
                  alt="pikanteria"
                />
                <img
                  className="pictureTwo"
                  src="https://images2.imgbox.com/a5/3e/dHUUDi9v_o.jpg"
                  alt="pikanteria2"
                />
              </div>
            </div>
          </div>
          <div className="right">
            <h1 className="section-title">
              Odkryj nasze smakowite propozycje!
            </h1>
            <p className="section-description">
              Zapraszamy do świata wyjątkowych smaków. W naszej ofercie
              znajdziesz starannie dobrane potrawy, które zachwycą Twoje
              podniebienie. Każde danie jest przygotowywane z najwyższą
              dbałością o jakość i świeżość.
            </p>

            <div className="promoCards">
              <img
                src="https://images2.imgbox.com/78/05/jypX4ezi_o.jpg"
                alt="Promocja"
                className="promo-image"
              />
              <img
                src="https://images2.imgbox.com/08/40/5RWi79Kt_o.jpg"
                alt="Promocja"
                className="promo-image"
              />
              <img
                src="https://images2.imgbox.com/26/b6/WevGfH1Z_o.jpg"
                alt="Promocja"
                className="promo-image"
              />
              <img
                src="https://images2.imgbox.com/65/34/b7hKzqvP_o.jpg"
                alt="Promocja"
                className="promo-image"
              />
            </div>
          </div>
          <h2 className="map-title">Tu nas znajdziesz</h2>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.8209310237585!2d16.826151476816342!3d52.228471071986164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470453c9efc27f11%3A0x83511605d417ec5b!2sPikanteria%20Food%20%26%20Friends!5e0!3m2!1spl!2spl!4v1740584305218!5m2!1spl!2spl"
              width="100%"
              height="550"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="onlineButton">
            <Link to="/menu" style={{ textDecoration: "none" }}>
              <button className="menuButton">ZAMÓW ONLINE</button>
            </Link>
          </div>
        </div>
      </div>
      {/* <HomepagePopup /> */}
    </div>
  );
};

export default Home;
